import { App, ConfigProvider } from 'antd';
import { SITE } from 'config/config';
import ReactDOM from 'react-dom/client';
import 'styles/global.css';
import { CONST_SITE } from 'utils/common/const';
import Apps from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
const colorSite = SITE === CONST_SITE.Jun88K36 ? '#26A9E0' : '#26A9E0';

root.render(
  <ConfigProvider
    prefixCls="okvip"
    iconPrefixCls=""
    theme={{
      token: {
        colorPrimary: colorSite,
        colorInfo: colorSite,
        borderRadius: 4
      },
      components: {
        Button: {
          colorPrimary: colorSite
        },
        Layout: {
          headerHeight: 20
        }
      }
    }}
  >
    <App
      notification={{
        placement: 'top'
      }}
    >
      <Apps />
    </App>
  </ConfigProvider>
);
